import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {CuiScrollContainer} from '../shared/scroll-container';

@Component({
  selector: 'cui-pagetip',
  templateUrl: './pagetip.component.html',
  styleUrls: ['./pagetip.component.scss']
})
export class CuiPagetipComponent {
  @HostBinding('class.shown')
  @Input()
  isShown = false;

  @Output()
  isShownChange = new EventEmitter();

  private lastScrollPosition = 0;

  constructor(private container: CuiScrollContainer) {
    this.container.scroll.subscribe(() => this.handleScroll());
  }

  handleScroll(): void {
    const position = this.container.getScrollPosition();
    const distance = position - this.lastScrollPosition;

    if (distance > 0) {
      this.isShown = false;
      this.isShownChange.next(this.isShown);
    } else if (distance < 0) {
      this.isShown = true;
      this.isShownChange.next(this.isShown);
    }

    this.lastScrollPosition = position;
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/pagetip/pagetip.component.ts